// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/pizzamax/bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/pizzamax/left.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/pizzamax/right.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  list-style-type: none;
  text-decoration: none;
  outline: none;
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
  font-family: "Poppins", sans-serif;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
  margin: 0px;
}
p {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  font-weight: 400;
  padding: 0;
  margin-bottom: 10px;
  line-height: 27px;
  color: #000000;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
img {
  max-width: 100%;
  border: none;
}
a {
  text-decoration: none;
  outline: none !important;
}
.p-80 {
  padding: 80px 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.main_area {
  position: relative;
  z-index: 1;
  color: white;
}
.main_area::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.2;
  z-index: -1;
}

/*-- header area start --*/
.headerarea {
  background-color: #fff;
  box-shadow: none;
  position: relative;
  z-index: 9;
  padding: 0;
}
.headerarea .logo {
  width: 100%;
  max-width: 150px;
}
.headerarea .logo img {
  width: 100%;
  object-fit: cover;
}
.headerarea .header-contact .call {
  width: 100%;
  min-width: 43px;
  max-width: 43px;
  height: 43px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f6f7fb;
  background-color: #f6f7fb;
  color: #000000;
  border-radius: 100%;
  margin-left: 10px;
  transition: 0.5s;
}
.headerarea .header-contact .call:hover {
  border-color: #000000;
  background-color: #000000;
  color: #ffffff;
}
.headerarea.fix {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 91;
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: fadeInDown;
  box-shadow: 0px 0px 20px 0px #e8e8e8;
}
.header-right .header-contact .btn {
  margin-right: 10px;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.header-right .menu {
  border-radius: 25px;
  margin-right: 30px;
}

.btn-login {
  background-color: #ffd105;
  color: #000;
  text-transform: capitalize;
  font-weight: 500;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 15px;
  border-radius: 8px;
  gap: 5px;
  font-size: 18px;
}
.btn-login:hover {
  background-color: #ea242c;
  color: #fff;
}
.btn-login span {
  max-width: 20px;
  height: 17px;
  display: inline-flex;
}
.btn-login span img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.btn-login:hover span img {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%)
    hue-rotate(156deg) brightness(103%) contrast(101%);
}
.header-body .header-right {
  padding-bottom: 20px;
}
/*menu CSS
--------------------------------------------------------------------------------------------------*/

.menu ul {
  margin: 0;
  padding: 0;
  font-size: 0;
}
.menu ul li {
  display: inline-block;
  padding: 0;
  list-style-type: none;
  position: relative;
  vertical-align: middle;
}
.menu ul li.active {
  position: relative;
}
.menu ul li:nth-of-type(5) {
  margin-left: 300px;
}
.menu ul li.active::before {
  content: "";
  position: absolute;
  top: -5px;
  left: 0;
  width: 100%;
  max-width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  /* background-image: url(./assets/pizzamax/menu-active-shape.svg); */
}
.menu ul li span {
  position: absolute;
  top: 45%;
  right: 10px;
}
.menu ul li span::after {
  content: "\\2b";
  color: #000000;
  font-family: FontAwesome;
  font-size: 10px;
}
.menu ul li:hover span::after {
  color: #f7c624;
}
.headarea.innerheader .menu ul li a {
  color: #000;
}
.menu ul li a {
  color: #000;
  font-size: 18px;
  text-transform: capitalize;
  font-weight: 500;
  display: block;
  padding: 7px 30px;
  position: relative;
  transition: all 0.5s ease;
}
.menu ul li a:hover,
.menu ul li.active a {
  color: #0859b2;
  background: #ffffff;
  border-radius: 0;
}
.menu ul li.active a::after {
  width: 100%;
}
.menu ul li a span {
  display: inline-block;
  vertical-align: 0px;
  margin-left: 6px;
  font-size: 10px;
}
.menu ul li:hover ul li a:hover {
  color: #000;
  background: #fff;
  border-radius: 25px;
}
.menu ul li ul {
  width: 240px;
  position: absolute;
  top: calc(100% + 30px);
  left: 0;
  z-index: 2;
  background-color: #ffffff;
  text-align: left;
  transition: 0.3s;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 4px 15px rgb(0 0 0 / 3%);
}
.menu ul ul li:first-child:before {
  display: none;
}
.menu ul ul li:after {
  display: none;
}
.menu ul li:last-child ul {
  width: 220px;
  position: absolute;
  top: 100%;
  left: auto;
  right: 0;
  z-index: 2;
  background-color: #ffffff;
  box-shadow: 0px 5px 14px rgb(0 0 0 / 2%);
  text-align: left;
}
.menu ul li ul li a {
  font-size: 14px;
  text-transform: none;
  padding: 12px 15px;
  color: #000;
  line-height: 20px;
  font-weight: 500;
  transition: all ease-in-out 0.5s;
  -moz-transition: all ease-in-out 0.5s;
  -webkit-transition: all ease-in-out 0.5s;
  -o-transition: all ease-in-out 0.5s;
  -ms-transition: all ease-in-out 0.5s;
  -khtml-transition: all ease-in-out 0.5s;
  display: block;
  margin: 0;
}
.menu ul li ul li ul {
  top: 10px;
  left: 149px;
}
.menu ul li ul li span {
  right: 7px;
  top: 12px;
}
.menu ul li a:hover.menu ul li ul {
  display: block;
}
.menu ul li ul li {
  display: block;
  padding: 0;
  border-bottom: solid 1px rgb(255 255 255 / 7%);
  border-right: none;
}
.menu ul li ul li:last-child {
  border: none;
}
.menuButton {
  width: 40px;
  height: 35px;
  padding: 5px;
  float: right;
  display: none;
}
.menuButton span {
  width: 100%;
  height: 2px;
  background: #000;
  margin-bottom: 6px;
  float: left;
  transition: all 0.3s ease-in-out 0s;
}
.menuButton span:last-child {
  margin-bottom: 0;
}
@media (min-width: 991.98px) {
  .menu ul {
    display: block !important;
  }
  .menu ul li:hover > ul {
    opacity: 1;
    top: 100%;
    visibility: visible;
  }
}
@media (max-width: 991.98px) {
  .menuButton {
    display: block;
    margin-left: 15px;
    cursor: pointer;
  }
  .menu ul li span {
    /* background: url(./assets/pizzamax/menu_arrow.png) center center no-repeat; */
    cursor: pointer;
    width: 15px;
    height: 15px;
    position: absolute;
    right: 15px;
    top: 20px;
    z-index: 99;
  }
  .menu ul li:hover span {
    /* background: url(./assets/pizzamax/menu_arrow_hover.png) center center no-repeat; */
  }
  .arrow_change span:nth-child(2) {
    display: none;
  }
  .arrow_change span:first-child {
    position: relative;
    top: 9px;
    transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  .arrow_change span:last-child {
    position: relative;
    top: 1px;
    transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  .menuBar {
    padding: 15px 0;
  }
  .menu {
    padding: 5px 0;
  }
  .menu ul {
    display: none;
    background-color: #fff;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 99;
  }
  .menu ul li a {
    color: #071731;
    display: block;
    width: 100%;
    font-size: 14px;
  }
  .menu ul li ul {
    display: none;
    background-color: #e1e1e1;
    position: relative;
    top: 5px;
    left: 0;
    width: 100%;
    z-index: 1;
    padding: 0;
    visibility: initial;
    opacity: 1;
  }
  .menu ul li:last-child ul {
    display: none;
    background-color: #e1e1e1;
    position: relative;
    top: 5px;
    left: 0;
    width: 100%;
    z-index: 1;
  }
  .menu ul li {
    display: block;
    padding: 10px 15px 10px 15px;
    border-top: 1px solid #cccccc54;
    text-align: left;
    position: relative;
  }
  .menu ul li span {
    position: absolute;
    right: 30px;
    z-index: 99;
    cursor: pointer;
    top: 12px;
    text-align: center;
  }
  .menu ul li ul li ul {
    top: 0;
    left: 0;
  }
  .menu ul li ul li a {
    font-size: 12px;
    text-transform: none;
    background-color: #e1e1e1;
    padding: 8px 12px;
    color: #000;
  }
}
.header-contact .mobile-ligin-dropdown {
  display: none;
}

.headerarea.fix .logo {
  max-width: 110px;
}

/* banner_area css */

.banner_area {
  min-height: 460px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding: 90px 0;
}

.orderbox_banner {
  max-width: 430px;
  background-color: rgb(255 255 255 / 82%);
  box-sizing: border-box;
  padding: 35px;
  border-radius: 8px;
  margin-left: 90px;
}

.orderbox_banner h1 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
}
.orderbox_banner h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 7px;
  text-transform: uppercase;
}
.chackboxarea {
  margin-bottom: 20px;
}
.chackboxarea label {
  display: inline-block;
  width: auto;
  padding: 9px 14px;
  background-color: #0859b2;
  color: #fff;
  border-radius: 30px;
  transition: all 0.3s;
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  max-width: 155px;
  width: 100%;
  text-align: center;
}

.chackboxarea input[type="radio"] {
  display: none;
}

.chackboxarea input[type="radio"]:checked + label {
  background-color: #f7c624;
  color: #000;
}
.orderbox_banner .selectbannerbox {
  border-radius: 5px;
  overflow: hidden;
  padding-right: 2px;
  border: 1px solid rgb(160 151 142);
}
.orderbox_banner .form-select {
  font-size: 14px;
  box-shadow: none;
  background-color: transparent;
  padding: 10px;
  border: 2px solid rgb(0 0 0 / 28%);
  margin-right: -2px;
  border-radius: 0;
}

.twoboxarea button {
  background-color: #0b59ae;
  width: 100%;
  border: none;
  font-size: 40px;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  box-sizing: border-box;
  padding: 30px;
  text-shadow: 0px 3px 4px rgb(0 0 0 / 67%);
  letter-spacing: 0.5px;
  cursor: pointer;
}
.twoboxarea button:hover {
  background-color: #ffd105;
  color: #000;
}
.heading-text {
  margin-bottom: 24px;
}
.heading-text h3 {
  font-size: 34px;
  font-weight: 800;
  text-transform: uppercase;
  color: #000000;
}

.bestseller_card {
  background-color: #fff;
  box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 12%);
  overflow: hidden;
  border-radius: 10px 10px 0px 0px;
  margin: 10px;
}
.bestseller_card .thumble {
  height: 264px;
  display: flex;
  background-position: -80px -3px;
  background-size: 122% 122%;
  background-repeat: no-repeat;
  width: 100%;
}
.bestseller_card p {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
}
.bestsellers-carousel .owl-nav {
  width: 100%;
  position: absolute;
  top: 185px;
}
.bestsellers-carousel .owl-prev,
.bestsellers-carousel .owl-next {
  width: 44px;
  height: 44px;
  border: 1px solid #efefef !important;
  border-radius: 50% !important;
  line-height: 28px !important;
  background: #ffffff !important;
  box-shadow: 2px 0px 4px rgb(0 0 0 / 42%);
}
.bestsellers-carousel .owl-prev:hover,
.bestsellers-carousel .owl-next:hover {
  background-color: #ffd105 !important;
}
.bestsellers-carousel .owl-nav button.owl-prev {
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: -5px;
  position: relative;
  font-size: 0px;
}
.bestsellers-carousel .owl-nav button.owl-prev span {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  width: 26px;
  height: 18px;
  background-position: center;
  background-size: contain;
}
.bestsellers-carousel .owl-nav button.owl-next {
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -5px;
  top: 0px;
  font-size: 0;
}
.bestsellers-carousel .owl-nav button.owl-next span {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 26px;
  height: 18px;
  background-position: center;
  background-size: contain;
  /* transform: rotate(180deg); */
  background-repeat: no-repeat;
}
/* .bestseller_card .thumble img{
  width: 100%;
  height: 100%;
  object-fit: cover;
} */

.bestseller_card .bodytext {
  box-sizing: border-box;
  padding: 24px;
}
.bestseller_card .bodytext h5 {
  color: #000;
  text-transform: uppercase;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 15px;
}
.bestseller_card .bodytext .outline-btnorder {
  color: #d32d3b;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid rgb(211 45 59 / 22%);
  display: inline-flex;
  padding: 7px 18px;
}
.bestseller_card .bodytext .outline-btnorder:hover {
  background-color: #d32d3b;
  color: #fff;
}




@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl {
      max-width: 1260px;
  }
  }
  
  
  
  
  @media (min-width: 320px){
    
  }
  `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,UAAU;EACV,kCAAkC;AACpC;AACA;;;;;;EAME,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAAgD;EAChD,YAAY;EACZ,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EAEX,sBAAsB;EAEtB,yBAAyB;EAEzB,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AAaA;EACE;IACE,UAAU;IAEV,mCAAmC;EACrC;EACA;IACE,UAAU;IAEV,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;sDACoD;AACtD;AACA;EACE,oBAAoB;AACtB;AACA;mGACmG;;AAEnG;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,oEAAoE;AACtE;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAKlB,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;EACd,SAAS;AACX;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,UAAU;EACV,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,+EAA+E;IAC/E,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;EACb;EACA;IACE,qFAAqF;EACvF;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;EAClC;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;EACb;EACA;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,UAAU;EACZ;EACA;IACE,cAAc;IACd,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,MAAM;IACN,OAAO;EACT;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;EACb;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;;AAEpB;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yDAAkD;EAClD,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;AACd;AACA;EACE,yDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;;;;GAIG;;AAEH;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;;;;AAKA;EACE;MACI,iBAAiB;EACrB;EACA;;;;;EAKA;;EAEA","sourcesContent":["@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n* {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n  text-decoration: none;\n  outline: none;\n  box-sizing: border-box;\n}\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: \"Poppins\", sans-serif;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\", sans-serif;\n  margin: 0px;\n}\np {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 17px;\n  font-weight: 400;\n  padding: 0;\n  margin-bottom: 10px;\n  line-height: 27px;\n  color: #000000;\n}\nul,\nli {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\nimg {\n  max-width: 100%;\n  border: none;\n}\na {\n  text-decoration: none;\n  outline: none !important;\n}\n.p-80 {\n  padding: 80px 0;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.main_area {\n  position: relative;\n  z-index: 1;\n  color: white;\n}\n.main_area::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(./assets/pizzamax/bg.webp);\n  opacity: 0.2;\n  z-index: -1;\n}\n\n/*-- header area start --*/\n.headerarea {\n  background-color: #fff;\n  box-shadow: none;\n  position: relative;\n  z-index: 9;\n  padding: 0;\n}\n.headerarea .logo {\n  width: 100%;\n  max-width: 150px;\n}\n.headerarea .logo img {\n  width: 100%;\n  object-fit: cover;\n}\n.headerarea .header-contact .call {\n  width: 100%;\n  min-width: 43px;\n  max-width: 43px;\n  height: 43px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #f6f7fb;\n  background-color: #f6f7fb;\n  color: #000000;\n  border-radius: 100%;\n  margin-left: 10px;\n  transition: 0.5s;\n}\n.headerarea .header-contact .call:hover {\n  border-color: #000000;\n  background-color: #000000;\n  color: #ffffff;\n}\n.headerarea.fix {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 91;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  box-shadow: 0px 0px 20px 0px #e8e8e8;\n}\n.header-right .header-contact .btn {\n  margin-right: 10px;\n}\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.header-right .menu {\n  border-radius: 25px;\n  margin-right: 30px;\n}\n\n.btn-login {\n  background-color: #ffd105;\n  color: #000;\n  text-transform: capitalize;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 8px 15px;\n  border-radius: 8px;\n  gap: 5px;\n  font-size: 18px;\n}\n.btn-login:hover {\n  background-color: #ea242c;\n  color: #fff;\n}\n.btn-login span {\n  max-width: 20px;\n  height: 17px;\n  display: inline-flex;\n}\n.btn-login span img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.btn-login:hover span img {\n  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%)\n    hue-rotate(156deg) brightness(103%) contrast(101%);\n}\n.header-body .header-right {\n  padding-bottom: 20px;\n}\n/*menu CSS\n--------------------------------------------------------------------------------------------------*/\n\n.menu ul {\n  margin: 0;\n  padding: 0;\n  font-size: 0;\n}\n.menu ul li {\n  display: inline-block;\n  padding: 0;\n  list-style-type: none;\n  position: relative;\n  vertical-align: middle;\n}\n.menu ul li.active {\n  position: relative;\n}\n.menu ul li:nth-of-type(5) {\n  margin-left: 300px;\n}\n.menu ul li.active::before {\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  left: 0;\n  width: 100%;\n  max-width: 50px;\n  height: 50px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  /* background-image: url(./assets/pizzamax/menu-active-shape.svg); */\n}\n.menu ul li span {\n  position: absolute;\n  top: 45%;\n  right: 10px;\n}\n.menu ul li span::after {\n  content: \"\\2b\";\n  color: #000000;\n  font-family: FontAwesome;\n  font-size: 10px;\n}\n.menu ul li:hover span::after {\n  color: #f7c624;\n}\n.headarea.innerheader .menu ul li a {\n  color: #000;\n}\n.menu ul li a {\n  color: #000;\n  font-size: 18px;\n  text-transform: capitalize;\n  font-weight: 500;\n  display: block;\n  padding: 7px 30px;\n  position: relative;\n  -webkit-transition: all 0.5s ease;\n  -moz-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n.menu ul li a:hover,\n.menu ul li.active a {\n  color: #0859b2;\n  background: #ffffff;\n  border-radius: 0;\n}\n.menu ul li.active a::after {\n  width: 100%;\n}\n.menu ul li a span {\n  display: inline-block;\n  vertical-align: 0px;\n  margin-left: 6px;\n  font-size: 10px;\n}\n.menu ul li:hover ul li a:hover {\n  color: #000;\n  background: #fff;\n  border-radius: 25px;\n}\n.menu ul li ul {\n  width: 240px;\n  position: absolute;\n  top: calc(100% + 30px);\n  left: 0;\n  z-index: 2;\n  background-color: #ffffff;\n  text-align: left;\n  transition: 0.3s;\n  opacity: 0;\n  visibility: hidden;\n  box-shadow: 0 4px 15px rgb(0 0 0 / 3%);\n}\n.menu ul ul li:first-child:before {\n  display: none;\n}\n.menu ul ul li:after {\n  display: none;\n}\n.menu ul li:last-child ul {\n  width: 220px;\n  position: absolute;\n  top: 100%;\n  left: auto;\n  right: 0;\n  z-index: 2;\n  background-color: #ffffff;\n  box-shadow: 0px 5px 14px rgb(0 0 0 / 2%);\n  text-align: left;\n}\n.menu ul li ul li a {\n  font-size: 14px;\n  text-transform: none;\n  padding: 12px 15px;\n  color: #000;\n  line-height: 20px;\n  font-weight: 500;\n  transition: all ease-in-out 0.5s;\n  -moz-transition: all ease-in-out 0.5s;\n  -webkit-transition: all ease-in-out 0.5s;\n  -o-transition: all ease-in-out 0.5s;\n  -ms-transition: all ease-in-out 0.5s;\n  -khtml-transition: all ease-in-out 0.5s;\n  display: block;\n  margin: 0;\n}\n.menu ul li ul li ul {\n  top: 10px;\n  left: 149px;\n}\n.menu ul li ul li span {\n  right: 7px;\n  top: 12px;\n}\n.menu ul li a:hover.menu ul li ul {\n  display: block;\n}\n.menu ul li ul li {\n  display: block;\n  padding: 0;\n  border-bottom: solid 1px rgb(255 255 255 / 7%);\n  border-right: none;\n}\n.menu ul li ul li:last-child {\n  border: none;\n}\n.menuButton {\n  width: 40px;\n  height: 35px;\n  padding: 5px;\n  float: right;\n  display: none;\n}\n.menuButton span {\n  width: 100%;\n  height: 2px;\n  background: #000;\n  margin-bottom: 6px;\n  float: left;\n  transition: all 0.3s ease-in-out 0s;\n}\n.menuButton span:last-child {\n  margin-bottom: 0;\n}\n@media (min-width: 991.98px) {\n  .menu ul {\n    display: block !important;\n  }\n  .menu ul li:hover > ul {\n    opacity: 1;\n    top: 100%;\n    visibility: visible;\n  }\n}\n@media (max-width: 991.98px) {\n  .menuButton {\n    display: block;\n    margin-left: 15px;\n    cursor: pointer;\n  }\n  .menu ul li span {\n    /* background: url(./assets/pizzamax/menu_arrow.png) center center no-repeat; */\n    cursor: pointer;\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    right: 15px;\n    top: 20px;\n    z-index: 99;\n  }\n  .menu ul li:hover span {\n    /* background: url(./assets/pizzamax/menu_arrow_hover.png) center center no-repeat; */\n  }\n  .arrow_change span:nth-child(2) {\n    display: none;\n  }\n  .arrow_change span:first-child {\n    position: relative;\n    top: 9px;\n    transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n  .arrow_change span:last-child {\n    position: relative;\n    top: 1px;\n    transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n  }\n  .menuBar {\n    padding: 15px 0;\n  }\n  .menu {\n    padding: 5px 0;\n  }\n  .menu ul {\n    display: none;\n    background-color: #fff;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    z-index: 99;\n  }\n  .menu ul li a {\n    color: #071731;\n    display: block;\n    width: 100%;\n    font-size: 14px;\n  }\n  .menu ul li ul {\n    display: none;\n    background-color: #e1e1e1;\n    position: relative;\n    top: 5px;\n    left: 0;\n    width: 100%;\n    z-index: 1;\n    padding: 0;\n    visibility: initial;\n    opacity: 1;\n  }\n  .menu ul li:last-child ul {\n    display: none;\n    background-color: #e1e1e1;\n    position: relative;\n    top: 5px;\n    left: 0;\n    width: 100%;\n    z-index: 1;\n  }\n  .menu ul li {\n    display: block;\n    padding: 10px 15px 10px 15px;\n    border-top: 1px solid #cccccc54;\n    text-align: left;\n    position: relative;\n  }\n  .menu ul li span {\n    position: absolute;\n    right: 30px;\n    z-index: 99;\n    cursor: pointer;\n    top: 12px;\n    text-align: center;\n  }\n  .menu ul li ul li ul {\n    top: 0;\n    left: 0;\n  }\n  .menu ul li ul li a {\n    font-size: 12px;\n    text-transform: none;\n    background-color: #e1e1e1;\n    padding: 8px 12px;\n    color: #000;\n  }\n}\n.header-contact .mobile-ligin-dropdown {\n  display: none;\n}\n\n.headerarea.fix .logo {\n  max-width: 110px;\n}\n\n/* banner_area css */\n\n.banner_area {\n  min-height: 460px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n  padding: 90px 0;\n}\n\n.orderbox_banner {\n  max-width: 430px;\n  background-color: rgb(255 255 255 / 82%);\n  box-sizing: border-box;\n  padding: 35px;\n  border-radius: 8px;\n  margin-left: 90px;\n}\n\n.orderbox_banner h1 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.orderbox_banner h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 7px;\n  text-transform: uppercase;\n}\n.chackboxarea {\n  margin-bottom: 20px;\n}\n.chackboxarea label {\n  display: inline-block;\n  width: auto;\n  padding: 9px 14px;\n  background-color: #0859b2;\n  color: #fff;\n  border-radius: 30px;\n  transition: all 0.3s;\n  text-transform: capitalize;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  max-width: 155px;\n  width: 100%;\n  text-align: center;\n}\n\n.chackboxarea input[type=\"radio\"] {\n  display: none;\n}\n\n.chackboxarea input[type=\"radio\"]:checked + label {\n  background-color: #f7c624;\n  color: #000;\n}\n.orderbox_banner .selectbannerbox {\n  border-radius: 5px;\n  overflow: hidden;\n  padding-right: 2px;\n  border: 1px solid rgb(160 151 142);\n}\n.orderbox_banner .form-select {\n  font-size: 14px;\n  box-shadow: none;\n  background-color: transparent;\n  padding: 10px;\n  border: 2px solid rgb(0 0 0 / 28%);\n  margin-right: -2px;\n  border-radius: 0;\n}\n\n.twoboxarea button {\n  background-color: #0b59ae;\n  width: 100%;\n  border: none;\n  font-size: 40px;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #fff;\n  box-sizing: border-box;\n  padding: 30px;\n  text-shadow: 0px 3px 4px rgb(0 0 0 / 67%);\n  letter-spacing: 0.5px;\n  cursor: pointer;\n}\n.twoboxarea button:hover {\n  background-color: #ffd105;\n  color: #000;\n}\n.heading-text {\n  margin-bottom: 24px;\n}\n.heading-text h3 {\n  font-size: 34px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: #000000;\n}\n\n.bestseller_card {\n  background-color: #fff;\n  box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 12%);\n  overflow: hidden;\n  border-radius: 10px 10px 0px 0px;\n  margin: 10px;\n}\n.bestseller_card .thumble {\n  height: 264px;\n  display: flex;\n  background-position: -80px -3px;\n  background-size: 122% 122%;\n  background-repeat: no-repeat;\n  width: 100%;\n}\n.bestseller_card p {\n  margin-bottom: 15px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 24px;\n}\n.bestsellers-carousel .owl-nav {\n  width: 100%;\n  position: absolute;\n  top: 185px;\n}\n.bestsellers-carousel .owl-prev,\n.bestsellers-carousel .owl-next {\n  width: 44px;\n  height: 44px;\n  border: 1px solid #efefef !important;\n  border-radius: 50% !important;\n  line-height: 28px !important;\n  background: #ffffff !important;\n  box-shadow: 2px 0px 4px rgb(0 0 0 / 42%);\n}\n.bestsellers-carousel .owl-prev:hover,\n.bestsellers-carousel .owl-next:hover {\n  background-color: #ffd105 !important;\n}\n.bestsellers-carousel .owl-nav button.owl-prev {\n  margin-left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: -5px;\n  position: relative;\n  font-size: 0px;\n}\n.bestsellers-carousel .owl-nav button.owl-prev span {\n  background-image: url(./assets/pizzamax/left.webp);\n  background-repeat: no-repeat;\n  width: 26px;\n  height: 18px;\n  background-position: center;\n  background-size: contain;\n}\n.bestsellers-carousel .owl-nav button.owl-next {\n  margin-right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  right: -5px;\n  top: 0px;\n  font-size: 0;\n}\n.bestsellers-carousel .owl-nav button.owl-next span {\n  background-image: url(./assets/pizzamax/right.webp);\n  width: 26px;\n  height: 18px;\n  background-position: center;\n  background-size: contain;\n  /* transform: rotate(180deg); */\n  background-repeat: no-repeat;\n}\n/* .bestseller_card .thumble img{\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n} */\n\n.bestseller_card .bodytext {\n  box-sizing: border-box;\n  padding: 24px;\n}\n.bestseller_card .bodytext h5 {\n  color: #000;\n  text-transform: uppercase;\n  font-size: 26px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n.bestseller_card .bodytext .outline-btnorder {\n  color: #d32d3b;\n  font-size: 14px;\n  font-weight: 700;\n  border: 1px solid rgb(211 45 59 / 22%);\n  display: inline-flex;\n  padding: 7px 18px;\n}\n.bestseller_card .bodytext .outline-btnorder:hover {\n  background-color: #d32d3b;\n  color: #fff;\n}\n\n\n\n\n@media (min-width: 1200px) {\n  .container, .container-lg, .container-md, .container-sm, .container-xl {\n      max-width: 1260px;\n  }\n  }\n  \n  \n  \n  \n  @media (min-width: 320px){\n    \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
